
import { AddIcon } from "@chakra-ui/icons";
import {  Box, Circle,IconButton,Text} from "@chakra-ui/react";

export const resourceTitle = "Cadastro de depósito";
export const resourceSingularName = "Depósito";
export const resourcePluralName = "Depósitos";

// @todo: review endpoint
export const resourceKey = "endereco/deposito";

export const idKey = "id";



const headers = [
  { label: 'Selecionar',
    key: 'checkbox',
    isVisible: true 
  },
  {
    key: "id",
    label: "ID",
    isVisible: true,
  },
  {
    key: "status",
    label: "Status",
    isVisible: true,
  },
{
  key: "tipoCarga",
  label: "Tipo Carga",
  isVisible: true,
  render: (value: string, item: any) => {
    const getTipoCargaConfig = (tipo: string) => {
      const tipoLower = String(tipo).toLowerCase();
      if (tipoLower === "frios") return { 
        bg: "#1e90ff", 
        color: "white", 
        icon: "F", 
        iconBg: "#1e90ff" 
      };
      if (tipoLower === "secos") return { 
        bg: "#ffd700", 
        color: "white", 
        icon: "S", 
        iconBg: "#ffd700" 
      };
      if (tipoLower === "misto") return { 
        bg: "#8B4513", 
        color: "white", 
        icon: "M", 
        iconBg: "#8B4513" 
      };
      return { bg: "#718096", color: "white", icon: "?", iconBg: "#718096" };
    };

    if (!value) return "-";
    
    const config = getTipoCargaConfig(value);
    
    return (
      <Box display="flex" alignItems="center" gap={2}>
        <Circle size="20px" bg={config.iconBg} color={config.color} fontSize="xs" fontWeight="bold">
          {config.icon}
        </Circle>
        <Text fontSize="sm" fontWeight="medium" textTransform="capitalize">
          {value}
        </Text>
      </Box>
    );
  }
},
{
  key: "prioridade",
  label: "Prioridade",
  isVisible: true,
  render: (value: string, item: any) => {
    const getPrioridadeConfig = (prioridade: string) => {
      const prioridadeLower = String(prioridade).toLowerCase();
      if (prioridadeLower === "baixa") return { 
        bg: "#28a745", 
        color: "white", 
        icon: "B", 
        iconBg: "#28a745" 
      };
      if (prioridadeLower === "normal") return { 
        bg: "#fd7e14", 
        color: "white", 
        icon: "N", 
        iconBg: "#ffd700" 
      };
      if (prioridadeLower === "urgente") return { 
        bg: "#dc3545", 
        color: "white", 
        icon: "U", 
        iconBg: "#dc3545" 
      };
      return { bg: "#718096", color: "white", icon: "?", iconBg: "#718096" };
    };

    if (!value) return "-";
    
    const config = getPrioridadeConfig(value);
    
    return (
      <Box display="flex" alignItems="center" gap={2}>
        <Circle size="20px" bg={config.iconBg} color={config.color} fontSize="xs" fontWeight="bold">
          {config.icon}
        </Circle>
        <Text fontSize="sm" fontWeight="medium" textTransform="capitalize">
          {value}
        </Text>
      </Box>
    );
  }
},
  {
    key: "tipoCarro",
    label: "Tipo de carro",
    isVisible: true,
  },
  {
    key: "dataDemanda",
    label: "Data Demanda",
    isVisible: true,
  },
  {
    key: "origem",
    label: "Origem",
    isVisible: true,
  },
  {
    key: "destino",
    label: "Destino",
    isVisible: true,
  },
  {
    key: "obs",
    label: "Obs",
    isVisible: true,
  },
  {
    key: "comentario",
    label: "Comentário",
    isVisible: true,
    render: (_value: string, item: any) => (
      <Box display="flex" justifyContent={'center'} alignItems="center" gap={2}>
        <IconButton
          aria-label="Add"
          icon={<AddIcon />}
          onClick={()=>  window.location.href = `/acompanhamento-portaria/acompanhamento-contratacao/comentario/${item.id}`}
          colorScheme="green"
          size="xs"
          borderRadius="full"
        />
      </Box>
    )
  }
];

export default headers;


export const mockData = [
  {
    Status: ["Em Confirmada", "Normal"],
    Ordem: "2075485",
    Carga: "Carga A123",
    DT: "DT-456789",
    Movimento: "Expedição",
    Janela: "08:00-12:00",
    ObsContratacao: "DT P.C.A 1022147 / CROSS 1022149 CARGA DESCARREGADA 100% NA FILIAL",
    ObsDemandante: "DT P.C.A 1022147 / CROSS 1022149 CARGA DESCARREGADA 100% NA FILIAL",
    DtPrevista: "04/08/2025",
    Origem: "São Paulo",
    Destino: "Rio de Janeiro",
    Motorista: "DEWILSON NUNES RAMOS",
    Placa: "ABC-1234",
    Doca: "Doca 3",
    PrevEntrada: "06/08/2025",
    DtChegada: "06/08/2025",
    HoraChegada: "10:30",
    DTEntrada: "DT-001",
    HoraEntrada: "08/08/2025",
    DtSaida: "08/08/2025",
    HoraSaida: "14:00",
    ObsDescarrego: "Descarregado por completo"
  },
  {
    Status: ["Em Confirmado", "Urgente"],
    Ordem: "10541938",
    Carga: "Carga B456",
    DT: "DT-987654",
    Movimento: "Coleta",
    Janela: "13:00-17:00",
    ObsContratacao: "Contrato padrão XYZ",
    ObsDemandante: "Observação do cliente: Fragil",
    DtPrevista: "05/08/2025",
    Origem: "Morada Nova",
    Destino: "Fortaleza",
    Motorista: "Ana Paula Silva",
    Placa: "XYZ-5678",
    Doca: "Doca 1",
    PrevEntrada: "05/08/2025",
    DtChegada: "05/08/2025",
    HoraChegada: "15:00",
    DTEntrada: "DT-002",
    HoraEntrada: "09:00",
    DtSaida: "05/08/2025",
    HoraSaida: "16:00",
    ObsDescarrego: "Aguardando liberação do cliente"
  },
  {
    Status: ["Urgente", "Baixa"],
    Ordem: "1025478",
    Carga: "Carga C789",
    DT: "DT-112233",
    Movimento: "Frio",
    Janela: "09:00-11:00",
    ObsContratacao: "Requer refrigeração constante",
    ObsDemandante: "Prioridade máxima para entrega",
    DtPrevista: "03/08/2025",
    Origem: "Recife",
    Destino: "Salvador",
    Motorista: "Carlos Eduardo Costa",
    Placa: "DEF-9012",
    Doca: "Doca 2",
    PrevEntrada: "03/08/2025",
    DtChegada: "03/08/2025",
    HoraChegada: "15:30",
    DTEntrada: "DT-003",
    HoraEntrada: "08:00",
    DtSaida: "08/08/2025",
    HoraSaida: "08:00",
    ObsDescarrego: "DT P.C.A 1022147 / CROSS 1022149 CARGA DESCARREGADA 100% NA FILIAL"
  },
   {
    Status: ["Em Confirmado", "Urgente"],
    Ordem: "10541938",
    Carga: "Carga B456",
    DT: "DT-987654",
    Movimento: "Coleta",
    Janela: "13:00-17:00",
    ObsContratacao: "Contrato padrão XYZ",
    ObsDemandante: "Observação do cliente: Fragil",
    DtPrevista: "05/08/2025",
    Origem: "Morada Nova",
    Destino: "Fortaleza",
    Motorista: "Ana Paula Silva",
    Placa: "XYZ-5678",
    Doca: "Doca 1",
    PrevEntrada: "05/08/2025",
    DtChegada: "05/08/2025",
    HoraChegada: "15:00",
    DTEntrada: "DT-002",
    HoraEntrada: "09:00",
    DtSaida: "05/08/2025",
    HoraSaida: "16:00",
    ObsDescarrego: "Aguardando liberação do cliente"
  },
     {
    Status: ["Em Confirmado", "Urgente"],
    Ordem: "10541938",
    Carga: "Carga B456",
    DT: "DT-987654",
    Movimento: "Coleta",
    Janela: "13:00-17:00",
    ObsContratacao: "Contrato padrão XYZ",
    ObsDemandante: "Observação do cliente: Fragil",
    DtPrevista: "05/08/2025",
    Origem: "Morada Nova",
    Destino: "Fortaleza",
    Motorista: "Ana Paula Silva",
    Placa: "XYZ-5678",
    Doca: "Doca 1",
    PrevEntrada: "05/08/2025",
    DtChegada: "05/08/2025",
    HoraChegada: "15:00",
    DTEntrada: "DT-002",
    HoraEntrada: "09:00",
    DtSaida: "05/08/2025",
    HoraSaida: "16:00",
    ObsDescarrego: "Aguardando liberação do cliente"
  },
     {
    Status: ["Em Confirmado", "Urgente"],
    Ordem: "10541938",
    Carga: "Carga B456",
    DT: "DT-987654",
    Movimento: "Coleta",
    Janela: "13:00-17:00",
    ObsContratacao: "Contrato padrão XYZ",
    ObsDemandante: "Observação do cliente: Fragil",
    DtPrevista: "05/08/2025",
    Origem: "Morada Nova",
    Destino: "Fortaleza",
    Motorista: "Ana Paula Silva",
    Placa: "XYZ-5678",
    Doca: "Doca 1",
    PrevEntrada: "05/08/2025",
    DtChegada: "05/08/2025",
    HoraChegada: "15:00",
    DTEntrada: "DT-002",
    HoraEntrada: "09:00",
    DtSaida: "05/08/2025",
    HoraSaida: "16:00",
    ObsDescarrego: "Aguardando liberação do cliente"
  },
  {
    Status: ["Urgente", "Baixa"],
    Ordem: "1025478",
    Carga: "Carga C789",
    DT: "DT-112233",
    Movimento: "Frio",
    Janela: "09:00-11:00",
    ObsContratacao: "Requer refrigeração constante",
    ObsDemandante: "Prioridade máxima para entrega",
    DtPrevista: "03/08/2025",
    Origem: "Recife",
    Destino: "Salvador",
    Motorista: "Carlos Eduardo Costa",
    Placa: "DEF-9012",
    Doca: "Doca 2",
    PrevEntrada: "03/08/2025",
    DtChegada: "03/08/2025",
    HoraChegada: "15:30",
    DTEntrada: "DT-003",
    HoraEntrada: "08:00",
    DtSaida: "08/08/2025",
    HoraSaida: "08:00",
    ObsDescarrego: "DT P.C.A 1022147 / CROSS 1022149 CARGA DESCARREGADA 100% NA FILIAL"
  }
]

export const mockLogisticaDataDetailed: any[] = [
  {
    Status: "Normal",
    Ordem: "1640",
    Carga: "1540",
    TipoCarga: "Frise",
    DtPrevista: "23/06/25",
    Motorista: "Marcelo Vieira de Moura",
    QtdVol: "25",
    Placa: "EZZ1234",
    DtChegada: "23/06/25",
    HoraChegada: "08:30",
    Doca: "5",
    DtEntrada: "23/06/29",
    HoraEntrada: "08:56",
    DataSaida: "23/06/25",
    HoraSaida: "12:35",
  },
  {
    Status: "Urgente",
    Ordem: "1640",
    Carga: "1540",
    TipoCarga: "Frise",
    DtPrevista: "23/06/25",
    Motorista: "Marcelo Vieira de Moura",
    QtdVol: "25",
    Placa: "EZZ1234",
    DtChegada: "23/06/25",
    HoraChegada: "08:30",
    Doca: "5",
    DtEntrada: "23/06/29",
    HoraEntrada: "08:56",
    DataSaida: "23/06/25",
    HoraSaida: "12:35",
  },
  {
    Status: "Urgente",
    Ordem: "1640",
    Carga: "1540",
    TipoCarga: "Frise",
    DtPrevista: "23/06/25",
    Motorista: "Marcelo Vieira de Moura",
    QtdVol: "25",
    Placa: "EZZ1234",
    DtChegada: "23/06/25",
    HoraChegada: "08:30",
    Doca: "5",
    DtEntrada: "23/06/29",
    HoraEntrada: "08:55",
    DataSaida: "23/06/25",
    HoraSaida: "12:35",
  },
  {
    Status: "Urgente",
    Ordem: "1640",
    Carga: "1540",
    TipoCarga: "Frise",
    DtPrevista: "23/06/25",
    Motorista: "Marcelo Vieira de Moura",
    QtdVol: "25",
    Placa: "EZZ1234",
    DtChegada: "23/06/25",
    HoraChegada: "08:30",
    Doca: "5",
    DtEntrada: "23/06/29",
    HoraEntrada: "08:55",
    DataSaida: "23/06/25",
    HoraSaida: "12:35",
  },
  {
    Status: "Urgente",
    Ordem: "1640",
    Carga: "1540",
    TipoCarga: "Frise",
    DtPrevista: "23/06/25",
    Motorista: "Marcelo Vieira de Moura",
    QtdVol: "25",
    Placa: "EZZ1234",
    DtChegada: "23/06/25",
    HoraChegada: "08:30",
    Doca: "5",
    DtEntrada: "23/06/29",
    HoraEntrada: "08:55",
    DataSaida: "23/06/25",
    HoraSaida: "12:35",
  },
  {
    Status: "Urgente",
    Ordem: "1640",
    Carga: "1540",
    TipoCarga: "Frise",
    DtPrevista: "23/06/25",
    Motorista: "Marcelo Vieira de Moura",
    QtdVol: "25",
    Placa: "EZZ1234",
    DtChegada: "23/06/25",
    HoraChegada: "08:30",
    Doca: "5",
    DtEntrada: "23/06/29",
    HoraEntrada: "08:55",
    DataSaida: "23/06/25",
    HoraSaida: "12:35",
  },
  {
    Status: "Urgente",
    Ordem: "1640",
    Carga: "1540",
    TipoCarga: "Frise",
    DtPrevista: "23/06/25",
    Motorista: "Marcelo Vieira de Moura",
    QtdVol: "25",
    Placa: "EZZ1234",
    DtChegada: "23/06/25",
    HoraChegada: "08:30",
    Doca: "5",
    DtEntrada: "23/06/29",
    HoraEntrada: "08:55",
    DataSaida: "23/06/25",
    HoraSaida: "12:35",
  },
  {
    Status: "Urgente",
    Ordem: "1640",
    Carga: "1540",
    TipoCarga: "Frise",
    DtPrevista: "23/06/25",
    Motorista: "Marcelo Vieira de Moura",
    QtdVol: "25",
    Placa: "EZZ1234",
    DtChegada: "23/06/25",
    HoraChegada: "08:30",
    Doca: "5",
    DtEntrada: "23/06/29",
    HoraEntrada: "08:55",
    DataSaida: "23/06/25",
    HoraSaida: "12:35",
  },
  {
    Status: "Baixa",
    Ordem: "1640",
    Carga: "1540",
    TipoCarga: "Frise",
    DtPrevista: "23/06/25",
    Motorista: "Marcelo Vieira de Moura",
    QtdVol: "25",
    Placa: "EZZ1234",
    DtChegada: "23/06/25",
    HoraChegada: "08:30",
    Doca: "5",
    DtEntrada: "23/06/29",
    HoraEntrada: "08:55",
    DataSaida: "23/06/25",
    HoraSaida: "12:35",
  },
  {
    Status: "Baixa",
    Ordem: "1640",
    Carga: "1540",
    TipoCarga: "Frise",
    DtPrevista: "23/06/25",
    Motorista: "Marcelo Vieira de Moura",
    QtdVol: "25",
    Placa: "EZZ1234",
    DtChegada: "23/06/25",
    HoraChegada: "08:30",
    Doca: "5",
    DtEntrada: "23/06/29",
    HoraEntrada: "08:55",
    DataSaida: "23/06/25",
    HoraSaida: "12:35",
  },
  {
    Status: "Baixa",
    Ordem: "1640",
    Carga: "1540",
    TipoCarga: "Frise",
    DtPrevista: "23/06/25",
    Motorista: "Marcelo Vieira de Moura",
    QtdVol: "25",
    Placa: "EZZ1234",
    DtChegada: "23/06/25",
    HoraChegada: "08:30",
    Doca: "5",
    DtEntrada: "23/06/29",
    HoraEntrada: "08:55",
    DataSaida: "23/06/25",
    HoraSaida: "12:35",
  },
  {
    Status: "Baixa",
    Ordem: "1640",
    Carga: "1540",
    TipoCarga: "Frise",
    DtPrevista: "23/06/25",
    Motorista: "Marcelo Vieira de Moura",
    QtdVol: "25",
    Placa: "EZZ1234",
    DtChegada: "23/06/25",
    HoraChegada: "08:30",
    Doca: "5",
    DtEntrada: "23/06/29",
    HoraEntrada: "08:55",
    DataSaida: "23/06/25",
    HoraSaida: "12:35",
  },
  {
    Status: "Normal",
    Ordem: "1640",
    Carga: "1540",
    TipoCarga: "Frise",
    DtPrevista: "23/06/25",
    Motorista: "Marcelo Vieira de Moura",
    QtdVol: "25",
    Placa: "EZZ1234",
    DtChegada: "23/06/25",
    HoraChegada: "08:30",
    Doca: "5",
    DtEntrada: "23/06/29",
    HoraEntrada: "08:56",
    DataSaida: "23/06/25",
    HoraSaida: "12:35",
    },
  {
    Status: "Urgente",
    Ordem: "1640",
    Carga: "1540",
    TipoCarga: "Frise",
    DtPrevista: "23/06/25",
    Motorista: "Marcelo Vieira de Moura",
    QtdVol: "25",
    Placa: "EZZ1234",
    DtChegada: "23/06/25",
    HoraChegada: "08:30",
    Doca: "5",
    DtEntrada: "23/06/29",
    HoraEntrada: "08:55",
    DataSaida: "23/06/25",
    HoraSaida: "12:35",
  },
  {
    Status: "Urgente",
    Ordem: "1640",
    Carga: "1540",
    TipoCarga: "Frise",
    DtPrevista: "23/06/25",
    Motorista: "Marcelo Vieira de Moura",
    QtdVol: "25",
    Placa: "EZZ1234",
    DtChegada: "23/06/25",
    HoraChegada: "08:30",
    Doca: "5",
    DtEntrada: "23/06/29",
    HoraEntrada: "08:55",
    DataSaida: "23/06/25",
    HoraSaida: "12:35",
  },
  {
    Status: "Baixa",
    Ordem: "1640",
    Carga: "1540",
    TipoCarga: "Frise",
    DtPrevista: "23/06/25",
    Motorista: "Marcelo Vieira de Moura",
    QtdVol: "25",
    Placa: "EZZ1234",
    DtChegada: "23/06/25",
    HoraChegada: "08:30",
    Doca: "5",
    DtEntrada: "23/06/29",
    HoraEntrada: "08:55",
    DataSaida: "23/06/25",
    HoraSaida: "12:35",
  },
  {
    Status: "Baixa",
    Ordem: "1640",
    Carga: "1540",
    TipoCarga: "Frise",
    DtPrevista: "23/06/25",
    Motorista: "Marcelo Vieira de Moura",
    QtdVol: "25",
    Placa: "EZZ1234",
    DtChegada: "23/06/25",
    HoraChegada: "08:30",
    Doca: "5",
    DtEntrada: "23/06/29",
    HoraEntrada: "08:55",
    DataSaida: "23/06/25",
    HoraSaida: "12:35",
  },
  {
    Status: "Baixa",
    Ordem: "1640",
    Carga: "1540",
    TipoCarga: "Frise",
    DtPrevista: "23/06/25",
    Motorista: "Marcelo Vieira de Moura",
    QtdVol: "25",
    Placa: "EZZ1234",
    DtChegada: "23/06/25",
    HoraChegada: "08:30",
    Doca: "5",
    DtEntrada: "23/06/29",
    HoraEntrada: "08:55",
    DataSaida: "23/06/25",
    HoraSaida: "12:35",
  },
  {
    Status: "Baixa",
    Ordem: "1640",
    Carga: "1540",
    TipoCarga: "Frise",
    DtPrevista: "23/06/25",
    Motorista: "Marcelo Vieira de Moura",
    QtdVol: "25",
    Placa: "EZZ1234",
    DtChegada: "23/06/25",
    HoraChegada: "08:30",
    Doca: "5",
    DtEntrada: "23/06/29",
    HoraEntrada: "08:55",
    DataSaida: "23/06/25",
    HoraSaida: "12:35",
  },
  {
    Status: "Normal",
    Ordem: "1640",
    Carga: "1540",
    TipoCarga: "Frise",
    DtPrevista: "23/06/25",
    Motorista: "Marcelo Vieira de Moura",
    QtdVol: "25",
    Placa: "EZZ1234",
    DtChegada: "23/06/25",
    HoraChegada: "08:30",
    Doca: "5",
    DtEntrada: "23/06/29",
    HoraEntrada: "08:56",
    DataSaida: "23/06/25",
    HoraSaida: "12:35",
  },
];